export default __webpack_public_path__ + "static/media/Totem of Origins.f879aeae.jpg";